import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  applyButton: {
    position: 'relative',
    top: '-50px',
    left: '80px',
    display: 'none',
  },
  showButton: {
    display: 'block',
    marginTop: '-32px',
    marginLeft: '-35px',
  },
  autocomplete: {
    display: 'inline-block',
    '& .MuiFormControl-marginNormal': {
      marginTop: '8px',
    },
  },
}));

export default styles;
